export default function Footer() {
  return (
    <footer
      className="mt-24 border-t"
      style={{ borderColor: "var(--border)" }}
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-display font-black text-2xl tracking-tighter">
            AI <span style={{ color: "var(--ai)" }}>vs</span> HUMAN
          </div>
          <p className="mt-3 text-sm" style={{ color: "var(--text-dim)" }}>
            Can people still tell the difference? Vote, learn, and watch the gap close in real time.
          </p>
        </div>
        <div>
          <div className="label-mono mb-3">Partner</div>
          <ul className="space-y-2 text-sm" style={{ color: "var(--text-dim)" }}>
            <li>Sponsored Challenges</li>
            <li>Consulting & Training</li>
            <li>Premium Workshops</li>
          </ul>
        </div>
        <div>
          <div className="label-mono mb-3">Platform</div>
          <ul className="space-y-2 text-sm" style={{ color: "var(--text-dim)" }}>
            <li>Episodes & Reveals</li>
            <li>Audience Submissions</li>
            <li>Creator Tools</li>
          </ul>
        </div>
      </div>
      <div className="border-t" style={{ borderColor: "var(--border)" }}>
        <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12 py-5 flex items-center justify-between">
          <span className="label-mono">© 2026 AI vs Human</span>
          <span className="label-mono">Episode 001 — Live</span>
        </div>
      </div>
    </footer>
  );
}
